import InfoDetails from 'components/InfoDetails';
import Separator from 'components/Separator';
import './interiorInfo.scss'

const InteriorInfo = ({ data }) => {

    return (
        <div className='interior-info-container'>
            {
                data.interior_features.length > 0 && 
                <InfoDetails title={'Interior Features'} items={data.interior_features} />
            }
            {
                data.appliances.length > 0 &&
                <>
                    <Separator height={24} />
                    <InfoDetails title={'Appliances / Equipment'} items={data.appliances} />
                </>
            }
            {
                (data.interior_features.length === 0 && data.appliances.length === 0) &&
                <div className='no-data'>
                    <p>No Interior Features</p>
                </div>
            }
        </div>
    )
}


export default InteriorInfo;